import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useImageUpload from "../../../../hooks/useImageUpload";
import { CircularProgress, Box, Typography } from "@material-ui/core";
import { useAuth } from "../../../../contexts/AuthContext";

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

export default function UploadImage({ image, setImage, setUrl, setPathname }) {
  const { currentUser, updateProfilePicture } = useAuth();
  const { progress, url, pathname, error } = useImageUpload(
    image,
    currentUser.uid
  );
  const [errChange, setErrChange] = useState("");

  useEffect(() => {
    async function updateProfileURL() {
      try {
        await updateProfilePicture(url);
      } catch (err) {
        setErrChange("Profile Picture Change Went Wrong");
      }
    }

    if (url && pathname) {
      updateProfileURL();
      setImage(null);
      setUrl(url);
      setPathname(pathname);
    }
  }, [url, setImage, setUrl, setPathname, pathname, updateProfilePicture]);

  return (
    <div>
      {error && <Typography variant="body1">{error}</Typography>}
      {errChange && <Typography variant="body1">{errChange}</Typography>}
      <CircularProgressWithLabel value={progress} />
    </div>
  );
}
